import { Link } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import JsonLd from '@/components/feature/JsonLd';

const stats = [
  { value: '1,286+', label: '收录爆料文章' },
  { value: '18', label: '开放分享社群' },
  { value: '6', label: '内容方向' },
  { value: '每日', label: '内容更新频率' },
];

const values = [
  {
    icon: 'ri-search-eye-line',
    title: '真实可查',
    desc: '只收录来源清晰、可以追溯的公开信息，未经证实的传闻会明确标注，不制造假瓜。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '克制表达',
    desc: '讨论热点时保持克制，不夸大、不做人身攻击，把注意力留给事件本身。',
  },
  {
    icon: 'ri-lightbulb-line',
    title: '有价值地吃瓜',
    desc: '除了八卦，我们也关注行业观察与内容评价，希望每次浏览都能带走点东西。',
  },
];

const testimonials = [
  { name: '阿柚', role: '影视爱好者', text: '分类做得很清楚，追剧的时候直接看「影视热议」，结局复盘帖整理得特别到位。' },
  { name: '小柯', role: '社群成员', text: '分享群每天都有合集推送，不用自己到处翻，进群之后基本就不会错过热点了。' },
  { name: '乔乔', role: '内容从业者', text: '难得见到有网站会把内容原则写清楚，来源标注也比较负责，看起来比较放心。' },
];

export default function About() {
  return (
    <div className="page-enter min-h-screen bg-background-50">
      <title>关于我们 - 品牌介绍与内容原则 | 爆瓜福利</title>
      <meta
        name="description"
        content="了解爆瓜福利：我们是一个聚焦娱乐吃瓜的资讯与分享社区，坚持真实可查、克制表达与有价值的内容原则，聚合爆料、影视综艺热议与分享群资源。"
      />
      <meta name="keywords" content="爆瓜福利,关于爆瓜福利,娱乐吃瓜社区,内容原则,分享资源共享" />
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: '关于爆瓜福利',
          description: '爆瓜福利品牌介绍、网站定位、内容原则与联系方式。',
          inLanguage: 'zh-CN',
          mainEntity: {
            '@type': 'Organization',
            name: '爆瓜福利',
            description: '聚焦娱乐吃瓜的资讯与分享社区。',
            email: 'hello@baoguafuli.example',
          },
        }}
      />

      <SiteHeader />
      <main>
        <section className="border-b border-background-200 bg-background-100">
          <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
            <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />
            <div className="mt-6 grid gap-10 lg:grid-cols-2 lg:items-center">
              <div>
                <h1 className="font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl md:leading-tight">
                  一群爱看热闹
                  <br />
                  也爱认真整理的人
                </h1>
                <p className="mt-5 max-w-xl text-sm leading-8 text-foreground-700">
                  爆瓜福利诞生于一个很朴素的想法：娱乐热点很多，但真正有人愿意把它整理清楚的地方不多。于是我们做了一件小事——把散落在各个平台上的爆料、讨论与观察收集起来，按主题分类、标注来源，再配上经过梳理的解读，让「吃瓜」这件事变得省事一点，也清醒一点。
                </p>
                <div className="mt-7 flex flex-wrap gap-3">
                  <Link
                    to="/gossip"
                    className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                  >
                    浏览吃瓜广场
                  </Link>
                  <Link
                    to="/community"
                    className="whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
                  >
                    加入分享社区
                  </Link>
                </div>
              </div>
              <div className="grid gap-4 sm:grid-cols-2">
                {stats.map((stat) => (
                  <div key={stat.label} className="rounded-lg border border-background-200 bg-background-50 p-6">
                    <p className="font-heading text-3xl font-bold text-primary-600">{stat.value}</p>
                    <p className="mt-2 text-sm text-foreground-600">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
          <div className="max-w-2xl">
            <span className="text-xs font-medium tracking-[0.25em] text-primary-600">OUR VALUES</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">我们坚持的三件事</h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              内容行业的信任很难建立，却很容易失去。所以我们给自己定了三条不复杂但要坚持的原则。
            </p>
          </div>

          <div className="mt-10 grid gap-5 md:grid-cols-3">
            {values.map((value) => (
              <div key={value.title} className="card-rise rounded-lg border border-background-200 bg-background-100 p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                  <i className={`${value.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{value.title}</h3>
                <p className="mt-3 text-sm leading-7 text-foreground-600">{value.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="border-y border-background-200 bg-background-100">
          <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
              <div>
                <span className="text-xs font-medium tracking-[0.25em] text-primary-600">FEEDBACK</span>
                <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">大家怎么说</h2>
              </div>
              <Link to="/faq" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                常见问题 →
              </Link>
            </div>

            <div className="mt-10 grid gap-5 md:grid-cols-3">
              {testimonials.map((item) => (
                <figure key={item.name} className="flex h-full flex-col rounded-lg bg-background-50 p-6">
                  <div className="flex items-center gap-1 text-secondary-500">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <i key={index} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <blockquote className="mt-4 flex-1 text-sm leading-7 text-foreground-700">“{item.text}”</blockquote>
                  <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-sm font-bold text-primary-700">
                      {item.name.slice(0, 1)}
                    </span>
                    <span>
                      <span className="block text-sm font-medium text-foreground-950">{item.name}</span>
                      <span className="block text-xs text-foreground-500">{item.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </section>

        <section className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
          <div className="grid gap-8 rounded-lg bg-foreground-950 p-8 md:grid-cols-2 md:p-12">
            <div>
              <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">联系我们</h2>
              <p className="mt-4 text-sm leading-8 text-background-100/85">
                无论是内容纠错、线索提供，还是合作咨询，都欢迎通过以下方式与我们取得联系。我们通常会在两个工作日内回复。
              </p>
            </div>
            <div className="space-y-4">
              <div className="flex items-center gap-4 rounded-lg border border-background-50/15 bg-background-50/5 p-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-mail-line text-xl"></i>
                </span>
                <span>
                  <span className="block text-xs text-background-100/70">邮箱</span>
                  <span className="block text-sm text-background-50">hello@baoguafuli.example</span>
                </span>
              </div>
              <div className="flex items-center gap-4 rounded-lg border border-background-50/15 bg-background-50/5 p-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                  <i className="ri-time-line text-xl"></i>
                </span>
                <span>
                  <span className="block text-xs text-background-100/70">回复时间</span>
                  <span className="block text-sm text-background-50">周一至周五 10:00 - 18:00</span>
                </span>
              </div>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}